import React from 'react';

const JobBookmarkIcon = ({ color = '#808080' }) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="40" height="40" rx="8" fill="#FCFBF8" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.9214 12.4198C21.3283 11.9851 18.6662 11.9851 16.073 12.4198C15.585 12.5016 15.1975 12.8765 15.1002 13.3595C14.2151 17.7535 14.1668 22.275 14.9578 26.6868L15.1214 27.599L18.7919 24.112C19.4674 23.4703 20.5271 23.4703 21.2025 24.112L24.8731 27.599L25.0366 26.6868C25.8276 22.275 25.7793 17.7535 24.8943 13.3595C24.797 12.8765 24.4094 12.5016 23.9214 12.4198ZM15.825 10.9404C18.5824 10.4782 21.4121 10.4782 24.1694 10.9404C25.2686 11.1247 26.1442 11.9685 26.3647 13.0633C27.2871 17.6422 27.3374 22.354 26.5131 26.9516L26.2916 28.1869C26.1057 29.2237 24.8416 29.6381 24.0779 28.9126L20.1694 25.1995C20.0729 25.1078 19.9215 25.1078 19.825 25.1995L15.9165 28.9126C15.1528 29.6381 13.8888 29.2237 13.7029 28.1869L13.4814 26.9516C12.6571 22.354 12.7074 17.6422 13.6297 13.0633C13.8502 11.9685 14.7258 11.1247 15.825 10.9404Z"
                fill={color}
            />
        </svg>
    );
};

export default JobBookmarkIcon;
